import { render } from "./consigne.vue?vue&type=template&id=f203c728"
import script from "./consigne.vue?vue&type=script&lang=js"
export * from "./consigne.vue?vue&type=script&lang=js"

import exportComponent from "/build/9647e414-6daa-46b0-8fd7-b2edfb8f7f7d/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__